import i18n, { TOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

import LogManager from 'es/core/logging/LogManager';
const logger = LogManager.getLogger('i18n');

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
        fallbackLng: 'en',
        debug: false,
        backend: {
            loadPath: (lngs: string, namespaces: string) => `/_i18n/${namespaces}/_i18n/l10n.${lngs}.json`,
        },
        ns: ['app'],
        defaultNS: 'app',
        detection: {
            // order and from where user language should be detected
            order: ['navigator'],
        },
        load: 'languageOnly',
        preload: ['en'],
        react: {
            useSuspense: true,
            bindI18n: 'languageChanged loaded',
            nsMode: 'default',
        },
        interpolation: {
            escapeValue: false,
        },
    });

i18n.loadNamespaces(['app', 'app/business-logic/services', 'core']).then(() =>
    logger.info('Default translation strings loaded')
);

export default i18n;

export const createl10n = (namespace: string | string[], prefix?: string) => {
    // noinspection JSIgnoredPromiseFromCall
    i18n.loadNamespaces(namespace);

    return (key: string, options?: TOptions) => {
        const keyParts: string[] = [];

        const hasNamespace = /:/.test(key);
        if (!hasNamespace) {
            const ns = Array.isArray(namespace) ? namespace[0] : namespace;
            if (typeof ns !== 'string') throw new Error(`Invalid i18n namespace: ${JSON.stringify(namespace)}`);
            keyParts.push(ns);
            keyParts.push(':');
        }

        if (prefix) {
            keyParts.push(`${prefix}.`);
        }

        keyParts.push(key);
        const qualifiedKey = keyParts.join('');

        return i18n.t(qualifiedKey, options);
    };
};
